import base64 from 'base-64';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getCookie: function(cname: any)
    {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++)
        {
            var c = ca[i]
            while (c.charAt(0) === ' ') 
            {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) 
            {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    },
    getUser: function()
    {
        let dados_user: any = this.getCookie("usuario_data");

        dados_user = base64.decode(dados_user);
        dados_user = JSON.parse(dados_user);
        return dados_user;
    }
}